// 粒子动画模块
export default class Particles {
  constructor(container, options = {}) {
    this.container = container;
    this.options = {
      zIndex: options.zIndex || -1,
      opacity: options.opacity || 0.8,
      color: options.color || '255,255,255',
      count: options.count || 350,
      maxDistance: options.maxDistance || 6000,
      mouseMaxDistance: options.mouseMaxDistance || 20000,
      lineWidth: options.lineWidth || 1,
      lineColor: options.lineColor || '#000000',
    };

    this.canvas = null;
    this.context = null;
    this.canvasWidth = 0;
    this.canvasHeight = 0;
    this.randomPoints = [];
    this.currentPoint = {
      x: null,
      y: null,
      max: this.options.mouseMaxDistance,
    };
    this.allArray = [];
    this.animationId = null;

    this.init();
  }

  init() {
    this.createCanvas();
    this.setCanvasSize();
    this.createRandomPoints();
    this.bindEvents();
    this.startAnimation();
  }

  createCanvas() {
    this.canvas = document.createElement('canvas');
    this.canvas.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: ${this.options.zIndex};
      opacity: ${this.options.opacity};
      pointer-events: none;
    `;
    this.context = this.canvas.getContext('2d');
    this.container.appendChild(this.canvas);
  }

  setCanvasSize() {
    this.canvasWidth = this.canvas.width = this.container.clientWidth;
    this.canvasHeight = this.canvas.height = this.container.clientHeight;
  }

  createRandomPoints() {
    this.randomPoints = [];
    for (let i = 0; i < this.options.count; i++) {
      const x = Math.random() * this.canvasWidth;
      const y = Math.random() * this.canvasHeight;
      const xa = 2 * Math.random() - 1;
      const ya = 2 * Math.random() - 1;

      this.randomPoints.push({
        x: x,
        y: y,
        xa: xa,
        ya: ya,
        max: this.options.maxDistance,
      });
    }
    this.allArray = this.randomPoints.concat([this.currentPoint]);
  }

  bindEvents() {
    // 窗口大小改变时重新设置画布大小
    const resizeHandler = () => {
      this.setCanvasSize();
      this.createRandomPoints();
    };

    window.addEventListener('resize', resizeHandler);
    this.resizeHandler = resizeHandler;

    // 鼠标移动事件 - 绑定到容器而不是canvas
    const mouseMoveHandler = (e) => {
      const rect = this.container.getBoundingClientRect();
      this.currentPoint.x = e.clientX - rect.left;
      this.currentPoint.y = e.clientY - rect.top;
    };

    const mouseOutHandler = () => {
      this.currentPoint.x = null;
      this.currentPoint.y = null;
    };

    // 绑定到容器元素，这样鼠标事件可以正常触发
    this.container.addEventListener('mousemove', mouseMoveHandler);
    this.container.addEventListener('mouseout', mouseOutHandler);

    this.mouseMoveHandler = mouseMoveHandler;
    this.mouseOutHandler = mouseOutHandler;
  }

  drawCanvas() {
    this.context.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

    // 遍历处理每一个点
    this.randomPoints.forEach((r, idx) => {
      r.x += r.xa;
      r.y += r.ya;

      // 碰到边界，反向反弹
      r.xa *= r.x > this.canvasWidth || r.x < 0 ? -1 : 1;
      r.ya *= r.y > this.canvasHeight || r.y < 0 ? -1 : 1;

      // 绘制点
      this.context.fillStyle = `rgb(${this.options.color})`;
      this.context.fillRect(r.x - 0.5, r.y - 0.5, 1, 1);

      // 从下一个点开始连线
      for (let i = idx + 1; i < this.allArray.length; i++) {
        const e = this.allArray[i];
        if (e.x !== null && e.y !== null) {
          const xDist = r.x - e.x;
          const yDist = r.y - e.y;
          const dist = xDist * xDist + yDist * yDist;

          if (dist < e.max) {
            // 鼠标吸附逻辑：当粒子距离鼠标在最大距离的一半以上时，粒子被吸引向鼠标
            if (e === this.currentPoint && dist >= e.max / 2) {
              r.x -= 0.03 * xDist;
              r.y -= 0.03 * yDist;
            }

            // 绘制连线
            const d = (e.max - dist) / e.max;
            this.context.beginPath();
            this.context.lineWidth = d / 2;
            this.context.strokeStyle = this.options.lineColor;
            this.context.moveTo(r.x, r.y);
            this.context.lineTo(e.x, e.y);
            this.context.stroke();
          }
        }
      }
    });

    this.animationId = requestAnimationFrame(() => this.drawCanvas());
  }

  startAnimation() {
    setTimeout(() => {
      this.drawCanvas();
    }, 100);
  }

  destroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }

    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }

    if (this.mouseMoveHandler) {
      this.container.removeEventListener('mousemove', this.mouseMoveHandler);
    }

    if (this.mouseOutHandler) {
      this.container.removeEventListener('mouseout', this.mouseOutHandler);
    }

    if (this.canvas && this.canvas.parentNode) {
      this.canvas.parentNode.removeChild(this.canvas);
    }
  }
}
